import type { Artifact, EntitlementVersion } from '../types';

/**
 * Gets the latest version from an artifact's versions array.
 * Assumes versions are pre-sorted with latest first.
 */
export const getLatestVersion = (
  artifacts: Artifact,
): EntitlementVersion | undefined => artifacts.versions[0];

/**
 * Gets the latest version from a versions array.
 * Assumes versions are pre-sorted with latest first.
 */
export const getLatestVersionFromArray = (
  versions: EntitlementVersion[],
): EntitlementVersion | undefined => versions[0];

/**
 * Gets a version property with a fallback value if undefined/null.
 */
export const getVersionProperty = <T extends keyof EntitlementVersion>(
  version: EntitlementVersion | undefined,
  property: T,
  fallback: string = 'N/A',
): string => {
  const value = version?.[property];

  return typeof value !== 'undefined' && value !== null
    ? String(value)
    : fallback;
};
